import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import InnerPage from '../components/InnerPage.jsx';
import { getPage, PAGE_REDIRECTS } from '../data/pagesContent.js';
import { rewriteAssetUrlsInHtml } from '../utils/paths.js';

function useDocumentMeta(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
}

/**
 * Renders a converted PHP inner page from the content registry.
 */
export default function ContentPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;

  if (PAGE_REDIRECTS[slug]) {
    return <Navigate to={PAGE_REDIRECTS[slug]} replace />;
  }

  const page = getPage(slug);
  useDocumentMeta(page?.title, page?.description);

  if (!page) {
    return <Navigate to="/" replace />;
  }

  return (
    <InnerPage
      slug={page.slug}
      heading={page.heading}
      lead={page.lead}
      banner={page.banner}
      section={page.section}
    >
      <div dangerouslySetInnerHTML={{ __html: rewriteAssetUrlsInHtml(page.html) }} />
    </InnerPage>
  );
}
